class PopulationBasedFundingUpdateIconSignal {
    public patientContactFacetId: string;
    public version: number;

    constructor(fields: Partial<PopulationBasedFundingUpdateIconSignal>) {
        this.patientContactFacetId = fields.patientContactFacetId ?? null;
        this.version = fields.version ?? 1;
    }
}

export { PopulationBasedFundingUpdateIconSignal };
